import router from '@/router.js'

export default {
    SPECIALISTS(state, response) {
        state.specialists = response.data;
        state.specialistsLoading = false;
    },
    CATEGORIES(state, response) {
        state.categories = response.data.categories;
        for(var i = 0; i < state.categories.length; i++) {
           if(state.categories[i].slug == router.currentRoute.params.slug) 
                state.selectedCategoryId = state.categories[i].id;
        }
    },
}
